import routes from '@/modules/city/city-routes';
import store from '@/modules/city/city-store';

export default {
  routes,
  store,
};
